import { AppRoutingModule } from './app-routing.module';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { createTranslateLoader, initializeTranslateService, loadConfig } from './app.config';
import { AuthenticationService } from '@services/authentication';
import { TokenInterceptor } from '@interceptors/token.interceptor';
import { OverlayContainer } from '@angular/cdk/overlay';
import { OverlayContainerService } from '@services/overlay-container-service/overlay-container.service';
import { IconsModule } from '@shared/icons/icons.module';
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastComponent } from './components/toast/toast.component';
import { LayoutComponent } from './components/layout/layout.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PermissionModule } from '@shared/permission/permission.module';
import { TopbarDropdownComponent } from './components/topbar-dropdown';
import { RightPanelComponent } from './components/right-panel/right-panel.component';
import { SidebarModule } from './components/sidebar/sidebar.module';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
    imports: [
        LayoutComponent,
        ToastComponent,
        TopbarComponent,
        TopbarDropdownComponent,
        ContactUsComponent,
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        IconsModule,
        NgbModalModule,
        NgbDropdownModule,
        NgSelectModule,
        PermissionModule,
        SidebarModule,
        RightPanelComponent,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpBackend]
            }
        }),
        SharedModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeTranslateService,
            deps: [TranslateService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: loadConfig,
            deps: [HttpBackend],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
            deps: [AuthenticationService]
        },
        { provide: OverlayContainer, useClass: OverlayContainerService },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
